var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"band-selector"},[_c('v-select',{attrs:{"items":_vm.bands,"label":"Tipo de Banda","outlined":true,"dense":"","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }